import { TFunction } from 'i18next';
import * as yup from 'yup';

interface ChangePasswordValidationObject {
  password: string;
  confirmPassword: string;
}

export const changePasswordValidationSchema = (
  t: TFunction<'translation', undefined>
) =>
  yup.object<ChangePasswordValidationObject>({
    currentPassword: yup
      .string()
      .required(t('change-password.current-password-required'))
      .min(8, t('auth.password-min-length', { count: 8 }))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
        t('auth.password-strength-message')
      ),
    newPassword: yup
      .string()
      .required(t('change-password.new-password-required'))
      .min(8, t('auth.password-min-length', { count: 8 }))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
        t('auth.password-strength-message')
      )
      .notOneOf(
        [yup.ref('currentPassword')],
        t('change-password.new-password-not-different')
      ),
  });
